/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientOverviewResource } from './';
import {
    ClientOverviewResourceFromJSON,
    ClientOverviewResourceFromJSONTyped,
    ClientOverviewResourceToJSON,
} from './';
import type { CostPlusOverviewResource } from './';
import {
    CostPlusOverviewResourceFromJSON,
    CostPlusOverviewResourceFromJSONTyped,
    CostPlusOverviewResourceToJSON,
} from './';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { FixedPriceContractDetailsResource } from './';
import {
    FixedPriceContractDetailsResourceFromJSON,
    FixedPriceContractDetailsResourceFromJSONTyped,
    FixedPriceContractDetailsResourceToJSON,
} from './';
import type { FreelancerOverviewResource } from './';
import {
    FreelancerOverviewResourceFromJSON,
    FreelancerOverviewResourceFromJSONTyped,
    FreelancerOverviewResourceToJSON,
} from './';
import type { PendingComplianceInformationResource } from './';
import {
    PendingComplianceInformationResourceFromJSON,
    PendingComplianceInformationResourceFromJSONTyped,
    PendingComplianceInformationResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerProjectResource
 */
export interface FreelancerProjectResource {
    /**
     * 
     * @type {string}
     * @memberof FreelancerProjectResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerProjectResource
     */
    correlationId: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerProjectResource
     */
    status: FreelancerProjectResourceStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof FreelancerProjectResource
     */
    pendingActions: Array<FreelancerProjectResourcePendingActionsEnum>;
    /**
     * 
     * @type {string}
     * @memberof FreelancerProjectResource
     */
    subject: string;
    /**
     * 
     * @type {ClientOverviewResource}
     * @memberof FreelancerProjectResource
     */
    client: ClientOverviewResource;
    /**
     * 
     * @type {FreelancerOverviewResource}
     * @memberof FreelancerProjectResource
     */
    freelancer: FreelancerOverviewResource;
    /**
     * 
     * @type {string}
     * @memberof FreelancerProjectResource
     */
    type: FreelancerProjectResourceTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerProjectResource
     */
    adminValidationForProposalRequired: boolean;
    /**
     * 
     * @type {Date}
     * @memberof FreelancerProjectResource
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FreelancerProjectResource
     */
    endDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FreelancerProjectResource
     */
    sortDateForFreelancer: Date;
    /**
     * 
     * @type {Date}
     * @memberof FreelancerProjectResource
     */
    acceptanceDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FreelancerProjectResource
     */
    cancellationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FreelancerProjectResource
     */
    plannedExpirationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FreelancerProjectResource
     */
    proposalCreationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FreelancerProjectResource
     */
    completionDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof FreelancerProjectResource
     */
    externalReference?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerProjectResource
     */
    uniqueConversationId?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerProjectResource
     */
    contractType?: FreelancerProjectResourceContractTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FreelancerProjectResource
     */
    clientPaymentMode?: FreelancerProjectResourceClientPaymentModeEnum;
    /**
     * 
     * @type {FixedPriceContractDetailsResource}
     * @memberof FreelancerProjectResource
     */
    fixedPriceContractDetails?: FixedPriceContractDetailsResource;
    /**
     * 
     * @type {CostPlusOverviewResource}
     * @memberof FreelancerProjectResource
     */
    costPlusContractDetails?: CostPlusOverviewResource;
    /**
     * 
     * @type {number}
     * @memberof FreelancerProjectResource
     */
    amountStillToBePaidByClient?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerProjectResource
     */
    renewable: boolean;
    /**
     * 
     * @type {Currency}
     * @memberof FreelancerProjectResource
     */
    currency: Currency;
    /**
     * 
     * @type {number}
     * @memberof FreelancerProjectResource
     */
    totalEstimatedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof FreelancerProjectResource
     */
    totalExpectedEarnings?: number;
    /**
     * 
     * @type {Date}
     * @memberof FreelancerProjectResource
     */
    paymentLimitDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerProjectResource
     */
    paymentBehindSchedule?: boolean;
    /**
     * 
     * @type {PendingComplianceInformationResource}
     * @memberof FreelancerProjectResource
     */
    pendingComplianceInformation?: PendingComplianceInformationResource;
}


/**
 * @export
 */
export const FreelancerProjectResourceStatusEnum = {
    Draft: 'DRAFT',
    Submitted: 'SUBMITTED',
    AcceptanceBlocked: 'ACCEPTANCE_BLOCKED',
    Upcoming: 'UPCOMING',
    InProgress: 'IN_PROGRESS',
    PaymentOnHold: 'PAYMENT_ON_HOLD',
    Ended: 'ENDED',
    Delivered: 'DELIVERED',
    Cancelled: 'CANCELLED',
    QuoteExpired: 'QUOTE_EXPIRED',
    PendingCompliance: 'PENDING_COMPLIANCE'
} as const;
export type FreelancerProjectResourceStatusEnum = typeof FreelancerProjectResourceStatusEnum[keyof typeof FreelancerProjectResourceStatusEnum];

/**
 * @export
 */
export const FreelancerProjectResourcePendingActionsEnum = {
    ModifyQuote: 'MODIFY_QUOTE',
    CompleteActivityTracker: 'COMPLETE_ACTIVITY_TRACKER',
    CompleteMission: 'COMPLETE_MISSION',
    LetProjectAppraisal: 'LET_PROJECT_APPRAISAL',
    GotoBusinessSettings: 'GOTO_BUSINESS_SETTINGS'
} as const;
export type FreelancerProjectResourcePendingActionsEnum = typeof FreelancerProjectResourcePendingActionsEnum[keyof typeof FreelancerProjectResourcePendingActionsEnum];

/**
 * @export
 */
export const FreelancerProjectResourceTypeEnum = {
    DraftQuote: 'DRAFT_QUOTE',
    ProjectProposal: 'PROJECT_PROPOSAL',
    CompletedProject: 'COMPLETED_PROJECT'
} as const;
export type FreelancerProjectResourceTypeEnum = typeof FreelancerProjectResourceTypeEnum[keyof typeof FreelancerProjectResourceTypeEnum];

/**
 * @export
 */
export const FreelancerProjectResourceContractTypeEnum = {
    FixedPrice: 'FIXED_PRICE',
    CostPlus: 'COST_PLUS'
} as const;
export type FreelancerProjectResourceContractTypeEnum = typeof FreelancerProjectResourceContractTypeEnum[keyof typeof FreelancerProjectResourceContractTypeEnum];

/**
 * @export
 */
export const FreelancerProjectResourceClientPaymentModeEnum = {
    PaymentByInvoice: 'PAYMENT_BY_INVOICE',
    Prepayment: 'PREPAYMENT'
} as const;
export type FreelancerProjectResourceClientPaymentModeEnum = typeof FreelancerProjectResourceClientPaymentModeEnum[keyof typeof FreelancerProjectResourceClientPaymentModeEnum];


/**
 * Check if a given object implements the FreelancerProjectResource interface.
 */
export function instanceOfFreelancerProjectResource(value: object): value is FreelancerProjectResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('correlationId' in value) || value['correlationId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('pendingActions' in value) || value['pendingActions'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('client' in value) || value['client'] === undefined) return false;
    if (!('freelancer' in value) || value['freelancer'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('adminValidationForProposalRequired' in value) || value['adminValidationForProposalRequired'] === undefined) return false;
    if (!('sortDateForFreelancer' in value) || value['sortDateForFreelancer'] === undefined) return false;
    if (!('renewable' in value) || value['renewable'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    return true;
}

export function FreelancerProjectResourceFromJSON(json: any): FreelancerProjectResource {
    return FreelancerProjectResourceFromJSONTyped(json, false);
}

export function FreelancerProjectResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerProjectResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'correlationId': json['correlationId'],
        'status': json['status'],
        'pendingActions': json['pendingActions'],
        'subject': json['subject'],
        'client': ClientOverviewResourceFromJSON(json['client']),
        'freelancer': FreelancerOverviewResourceFromJSON(json['freelancer']),
        'type': json['type'],
        'adminValidationForProposalRequired': json['adminValidationForProposalRequired'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'sortDateForFreelancer': (new Date(json['sortDateForFreelancer'])),
        'acceptanceDate': json['acceptanceDate'] == null ? undefined : (new Date(json['acceptanceDate'])),
        'cancellationDate': json['cancellationDate'] == null ? undefined : (new Date(json['cancellationDate'])),
        'plannedExpirationDate': json['plannedExpirationDate'] == null ? undefined : (new Date(json['plannedExpirationDate'])),
        'proposalCreationDate': json['proposalCreationDate'] == null ? undefined : (new Date(json['proposalCreationDate'])),
        'completionDate': json['completionDate'] == null ? undefined : (new Date(json['completionDate'])),
        'externalReference': json['externalReference'] == null ? undefined : json['externalReference'],
        'uniqueConversationId': json['uniqueConversationId'] == null ? undefined : json['uniqueConversationId'],
        'contractType': json['contractType'] == null ? undefined : json['contractType'],
        'clientPaymentMode': json['clientPaymentMode'] == null ? undefined : json['clientPaymentMode'],
        'fixedPriceContractDetails': json['fixedPriceContractDetails'] == null ? undefined : FixedPriceContractDetailsResourceFromJSON(json['fixedPriceContractDetails']),
        'costPlusContractDetails': json['costPlusContractDetails'] == null ? undefined : CostPlusOverviewResourceFromJSON(json['costPlusContractDetails']),
        'amountStillToBePaidByClient': json['amountStillToBePaidByClient'] == null ? undefined : json['amountStillToBePaidByClient'],
        'renewable': json['renewable'],
        'currency': CurrencyFromJSON(json['currency']),
        'totalEstimatedAmount': json['totalEstimatedAmount'] == null ? undefined : json['totalEstimatedAmount'],
        'totalExpectedEarnings': json['totalExpectedEarnings'] == null ? undefined : json['totalExpectedEarnings'],
        'paymentLimitDate': json['paymentLimitDate'] == null ? undefined : (new Date(json['paymentLimitDate'])),
        'paymentBehindSchedule': json['paymentBehindSchedule'] == null ? undefined : json['paymentBehindSchedule'],
        'pendingComplianceInformation': json['pendingComplianceInformation'] == null ? undefined : PendingComplianceInformationResourceFromJSON(json['pendingComplianceInformation']),
    };
}

export function FreelancerProjectResourceToJSON(value?: FreelancerProjectResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'correlationId': value['correlationId'],
        'status': value['status'],
        'pendingActions': value['pendingActions'],
        'subject': value['subject'],
        'client': ClientOverviewResourceToJSON(value['client']),
        'freelancer': FreelancerOverviewResourceToJSON(value['freelancer']),
        'type': value['type'],
        'adminValidationForProposalRequired': value['adminValidationForProposalRequired'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'sortDateForFreelancer': ((value['sortDateForFreelancer']).toISOString()),
        'acceptanceDate': value['acceptanceDate'] == null ? undefined : ((value['acceptanceDate']).toISOString()),
        'cancellationDate': value['cancellationDate'] == null ? undefined : ((value['cancellationDate']).toISOString()),
        'plannedExpirationDate': value['plannedExpirationDate'] == null ? undefined : ((value['plannedExpirationDate']).toISOString()),
        'proposalCreationDate': value['proposalCreationDate'] == null ? undefined : ((value['proposalCreationDate']).toISOString()),
        'completionDate': value['completionDate'] == null ? undefined : ((value['completionDate']).toISOString()),
        'externalReference': value['externalReference'],
        'uniqueConversationId': value['uniqueConversationId'],
        'contractType': value['contractType'],
        'clientPaymentMode': value['clientPaymentMode'],
        'fixedPriceContractDetails': FixedPriceContractDetailsResourceToJSON(value['fixedPriceContractDetails']),
        'costPlusContractDetails': CostPlusOverviewResourceToJSON(value['costPlusContractDetails']),
        'amountStillToBePaidByClient': value['amountStillToBePaidByClient'],
        'renewable': value['renewable'],
        'currency': CurrencyToJSON(value['currency']),
        'totalEstimatedAmount': value['totalEstimatedAmount'],
        'totalExpectedEarnings': value['totalExpectedEarnings'],
        'paymentLimitDate': value['paymentLimitDate'] == null ? undefined : ((value['paymentLimitDate']).toISOString()),
        'paymentBehindSchedule': value['paymentBehindSchedule'],
        'pendingComplianceInformation': PendingComplianceInformationResourceToJSON(value['pendingComplianceInformation']),
    };
}

